<template>
  <div class="wrapper">
    <parallax class="section page-header header-filter" :style="headerStyle"></parallax>
    <div class="main main-raised">
      <div class="section profile-content">
        <div class="container">
          <div class="full-control">
            <div class="list">
              <v-row>
                <v-col cols="4">
                  <md-content>
                    <img src="../assets/blog/blog7.jpeg">
                  </md-content>
                  <md-content style="text-align: justify;">
                      Obra de drenagem em Subestação, Barreias/BA.                     
                  </md-content>
                </v-col>   

                <v-col cols="4">
                  <md-content>
                    <img src="../assets/blog/blog3.jpeg">
                  </md-content>
                  <md-content style="text-align: justify;">
                      Tubo PEAD e Geotêxtil Centergeo, utilizados em sistema de drenagem.                    
                  </md-content>
                </v-col>   

                <v-col cols="4">
                  <md-content>
                   <img src="../assets/blog/blog10.jpeg">
                  </md-content>
                  <md-content style="text-align: justify;">
                      Geotextil e Tubodreno Centergeo, para obra de drenagem de rodovia.                   
                  </md-content>
                </v-col>                
              </v-row>

              <v-row>
                <v-col cols="4">
                  <md-content>
                    <img src="../assets/blog/blog2.jpeg">
                  </md-content>
                </v-col>
                 <v-col cols="8"> 
                  <md-content style="text-align: justify;">
                      Os drenos subterrâneos devem ser implantados durante o acabamento da terraplanagem, 
                        de modo a favorecer as condições construtivas. 
                        Os drenos cegos poderão ser executados sob a forma de trincheira ou colchão, de acordo 
                        com as recomendações de projeto, adequando-se às condições geométricas e inclinação da 
                        área a ser esgotada. 
                        Os drenos verticais de areia ou geossintéticos, cuja implantação é recomendada para os 
                        processos especiais de estabilização de maciço ou de camadas de terraplanagem, passíveis
                        de deformações por ruptura ou adensamento, serão tratados em especificação própria, 
                        decorrente de indicação dos estudos geotécnicos.                   
                  </md-content>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="4">
                  <md-content>
                     <img src="../assets/blog/blog5.jpeg">
                  </md-content>
                  <md-content style="text-align: justify;">
                      Geotêxtil Centergeo e Bermalonga, entregue para obra de recuperação  de áreas degradadas.               
                  </md-content>
                </v-col>

                <v-col cols="5">
                  <md-content>
                    <img style="width: 415px; height: 353px;" src="../assets/blog/blog11.jpeg">
                  </md-content>
                  <md-content style="padding-right: 10px;">
                      Centergeo presente em pequenas, médias e grandes obras, por todo Brasil!                   
                  </md-content>
                </v-col>

                <v-col cols="3">
                  <md-content>
                     <img src="../assets/blog/blog14.jpeg">
                  </md-content>
                  <md-content style="text-align: justify;">
                    Tubo PEAD corrugado com paredes criadas para drenagem ou esgoto! 
                    Aplicado para condução de grande volume de água ou esgoto.               
                  </md-content>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="4">
                  <md-content>
                      <img src="../assets/blog/blog4.jpeg">
                  </md-content>
                  <md-content style="text-align: justify;">
                    Geotêxtil Centergeo aplicado em obra de pavimentação do DER-ES.

                      A utilização de drenos de pavimentos construídos de geotêxtis filtrantes,
                      previne que a água na base seja penetrada pelo pavimento, evitando assim que 
                      o subleito e estrutura do pavimento sejam afetados na sua resistência e vida útil.              
                  </md-content>
                </v-col>

                <v-col cols="4">
                  <md-content>
                     <img src="../assets/blog/blog6.jpeg">
                  </md-content>
                  <md-content style="text-align: justify;">
                      TUBO DRENO PEAD CENTERGEO
                      Com sua flexibilidade, resistência e alta capacidade drenante, faz a capacitação e 
                      escoamento de líquidos em excesso, destinado a drenagem geral.                 
                  </md-content>
                </v-col>
                
                <v-col cols="4">
                  <md-content>
                     <img src="../assets/blog/blog8.jpeg">
                  </md-content>
                  <md-content style="text-align: justify;">
                      Geomembrana PEAD - Apresenta excelente performance quando utilizada como revestimento 
                      impermeável. Utilizaza em #lagoas  #contenção #piscicultura #reservatórios 
                      e muito mais...               
                  </md-content>
                </v-col>
              </v-row>
                      

              <v-row>
                <v-col cols="4">
                  <md-content>
                      <img src="../assets/blog/blog9.jpeg">
                  </md-content>
                  <md-content style="text-align: justify;">
                      Geocomposto LGT e Tubo Dreno Centergeo, aplicado em obra residencial em 
                      Poços de Caldas/MG.

                      Simples instalação, Economia, Elevada capacidade de fluxo, 
                      Maior capacidade de vazão, resistente
                  </md-content>
                </v-col>


                <v-col cols="4">
                  <md-content>
                      <img src="../assets/blog/blog12.jpeg">
                  </md-content>

                  <md-content style="text-align: justify;">
                      Geossintetico de alta resistência a tração e baixo alongamento, interligados com 
                      finalidade para reforço de solos. Através de seus orifícios e rugosidade, ocorre a 
                      interação com o solo envolvente, transmitindo suas particularidades mecânica, fazendo 
                      com que assim surja um novo material, o solo reforçado. Utilizado na criação de 
                      infraestrutura de contenção, pavimentos, aterros sobre solos de menor capacidade de 
                      suporte, bases, taludes íngremes, dentre outros.
                  </md-content>
                </v-col>

                <v-col cols="4">
                  <md-content>
                     <img src="../assets/blog/blog13.jpeg">
                  </md-content>

                  <md-content style="text-align: justify;">
                      Eletroduto Centergeo, fabricado em PEAD com secção anelar (corrugado) e, cabo guia. 
                      Com sua flexibilidade devido a corrugação, minimiza seu raio de curvatura. Altamente 
                      utilizado na proteção de cabeamentos elétricos, TV a cabo, 
                      instalações subterrâneas, dentre outros.
                  </md-content>
                </v-col>
              </v-row>
            </div>
          </div>   
        </div>
      </div>
      <div class="section" style="background: black">
        <information-footer></information-footer>
      </div>
    </div>    
  </div>
</template>

<script>
import InformationFooter from "../components/InformationFooter";

export default {
  components: { InformationFooter },
  bodyClass: "profile-page",
  data() {
    return {      
    };
  },
  props: {
    header: {
      type: String,
      default: require("@/assets/home/fundo.png")
    }
  },
  computed: {
    headerStyle() {
      return {
        backgroundImage: `url(${this.header})`
      };
    }
  }
};
</script>

<style lang="scss" scoped>
.section {
  padding: 0;
}

.projectImg {
  width: 200px;
  padding: 10px;
}

.profile-tabs::v-deep {
  .md-card-tabs .md-list {
    justify-content: center;
  }

  [class*="tab-pane-"] {
    margin-top: 3.213rem;
    padding-bottom: 50px;

    img {
      margin-bottom: 2.142rem;
    }
  }
}

.md-card {
  width: 320px;
  margin: 4px;
  display: inline-block;
  vertical-align: top;
}

.md-card .md-card-header {
  margin: -20px 20px 15px;
  border-radius: 3px;
  padding: 20px 0;
  box-shadow: unset;
  background-color: transparent;
}

.content {
  justify-content: flex-end;
}

.paragrafo {
  white-space: break-spaces; 
  text-align: justify;
}

.teste {
 width: 100%;
}
</style>
